import { DocumentDto } from '@app/generated/model';

export const getDocumentUrl = (_workOrderId: string, document: DocumentDto) => {
  return document.link.toString();
};
